/* BAVI · interactions. Achat, FAQ et contenus restent utilisables sans JavaScript. */
(() => {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const reduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  /* Menu */
  const menuButton = $('.menu-button');
  const drawer = $('#menu-drawer');
  const setMenu = (open, focus = false) => {
    if (!menuButton || !drawer) return;
    menuButton.setAttribute('aria-expanded', String(open));
    menuButton.setAttribute('aria-label', open ? 'Fermer le menu' : 'Ouvrir le menu');
    drawer.hidden = !open;
    document.body.classList.toggle("bavi-menu-open", open);
    if (!open && focus) menuButton.focus();
  };
  menuButton?.addEventListener('click', () => setMenu(menuButton.getAttribute('aria-expanded') !== 'true'));
  drawer?.addEventListener('click', e => { if (e.target.closest('a')) setMenu(false); });
  document.addEventListener('keydown', e => { if (e.key === 'Escape' && menuButton?.getAttribute('aria-expanded') === 'true') setMenu(false, true); });
  document.addEventListener('click', e => { if (!e.target.closest('.header-shell') && menuButton?.getAttribute('aria-expanded') === 'true') setMenu(false); });

  menuButton?.addEventListener('keydown', e => {
    if (e.key === 'ArrowDown') { e.preventDefault(); setMenu(true); $('a', drawer)?.focus(); }
  });
  const desktopMenu = matchMedia('(min-width: 1100px)');
  desktopMenu.addEventListener('change', e => { if (e.matches) setMenu(false); });

  /* Galerie : une vue indisponible revient au produit local. */
  const main = $('#gallery-main');
  const thumbs = $$('.gallery__thumbs button');
  const galleryStatus = $('#gallery-status');
  const restoreProductPhoto = () => {
    const fallback = main?.dataset.fallback;
    if (!fallback) return;
    const url = new URL(fallback, document.baseURI).href;
    if (main.src === url) {
      if (galleryStatus) galleryStatus.textContent = 'Cette photo ne charge pas. Vous pouvez explorer les autres vues.';
      return;
    }
    main.src = url;
    main.alt = thumbs[0]?.dataset.alt || 'Le produit BAVI';
    thumbs.forEach((button,index) => button.setAttribute('aria-pressed', String(index === 0)));
    if (galleryStatus) galleryStatus.textContent = 'Cette vue est indisponible. La photo du produit est affichée.';
  };
  main?.addEventListener('error', restoreProductPhoto);
  if (main?.complete && !main.naturalWidth) restoreProductPhoto();
  thumbs.forEach(t => t.addEventListener('click', () => {
    if (galleryStatus) galleryStatus.textContent = '';
    thumbs.forEach(b => b.setAttribute('aria-pressed', String(b === t)));
    main.src = t.dataset.src;
    main.alt = t.dataset.alt;
  }));

  /* Choix du format */
  const inputs = $$('.offer input');
  const sync = () => {
    const input = inputs.find(i => i.checked);
    if (!input) return;
    $$('[data-show-price]').forEach(n => { n.textContent = input.dataset.price; });
    $$('[data-show-day]').forEach(n => { n.textContent = input.dataset.day; });
    $$('[data-sticky-label]').forEach(n => { n.textContent = input.dataset.label; });
  };
  inputs.forEach(i => i.addEventListener('change', sync));
  sync();

  $$('form[action*="cart/add"]').forEach(form => form.addEventListener('submit', () => {
    $$('button[type="submit"]', form).concat(form.getAttribute('id') ? $$(`button[form="${form.getAttribute('id')}"]`) : [])
      .forEach(b => b.setAttribute('aria-busy', 'true'));
  }));

  /* Barre d’achat fixe : après le bloc d’achat, masquée quand il est visible et sur le footer */
  const sticky = $('#sticky-buy');
  const hero = $('.hero');
  const offers = $('#bavi-achat');
  const footer = $('#footer');
  if (sticky && offers) {
    const inView = n => { if (!n) return false; const b = n.getBoundingClientRect(); return b.bottom > 80 && b.top < innerHeight - 80; };
    let queued = false;
    const update = () => {
      queued = false;
      const past = hero ? hero.getBoundingClientRect().bottom < 0 : true;
      const show = past && !inView(offers) && !inView(footer);
      if (show === sticky.classList.contains('is-visible')) return;
      sticky.classList.toggle('is-visible', show);
      sticky.setAttribute('aria-hidden', String(!show));
      sticky.inert = !show;
    };
    const request = () => { if (!queued) { queued = true; requestAnimationFrame(update); } };
    addEventListener('scroll', request, {passive: true});
    addEventListener('resize', request);
    update();
  }

  /* Avis : 3 visibles, le reste sur demande */
  const reviews = $('.reviews');
  const moreReviews = $('[data-more-reviews]');
  if (reviews && moreReviews && $$('.review.is-extra', reviews).length) {
    moreReviews.hidden = false;
    moreReviews.addEventListener('click', () => {
      reviews.classList.add('is-open');
      moreReviews.hidden = true;
      moreReviews.setAttribute('aria-expanded', 'true');
    });
  }

  /* FAQ : 6 questions visibles, puis toutes */
  const faqItems = $$('.faq-item');
  const moreFaq = $('[data-more-faq]');
  if (faqItems.length > 6 && moreFaq) {
    faqItems.slice(6).forEach(i => { i.hidden = true; });
    moreFaq.hidden = false;
    moreFaq.addEventListener('click', () => {
      faqItems.forEach(i => { i.hidden = false; });
      moreFaq.hidden = true;
      moreFaq.setAttribute('aria-expanded', 'true');
      $('summary', faqItems[6])?.focus();
    });
  }

  /* Rituel : choix explicite, visibilité et préférence de mouvement. */
  const videos = $$('video[data-autoplay]');
  const motionButton = $('[data-ritual-motion]');
  const motionPreference = matchMedia('(prefers-reduced-motion: reduce)');
  let pausedByChoice = motionPreference.matches;
  const visibleVideos = new Map();
  const syncMotion = () => {
    motionButton?.setAttribute('aria-pressed', String(pausedByChoice));
    if (motionButton) motionButton.textContent = pausedByChoice ? 'Lire les animations' : 'Mettre les animations en pause';
    videos.forEach(video => {
      const shouldPlay = !pausedByChoice && !document.hidden && visibleVideos.get(video);
      if (shouldPlay) {
        video.preload = 'auto';
        if (video.paused) video.play().then(() => {
          if (pausedByChoice || document.hidden || !visibleVideos.get(video)) video.pause();
        }).catch(() => { video.controls = true; });
      } else video.pause();
    });
  };
  if (videos.length && 'IntersectionObserver' in window) {
    videos.forEach(video => { video.controls = false; });
    if (motionButton) motionButton.hidden = false;
    const io = new IntersectionObserver(entries => {
      entries.forEach(({target, isIntersecting, intersectionRatio}) => visibleVideos.set(target, isIntersecting && intersectionRatio >= .35));
      syncMotion();
    }, {threshold: [0, .35]});
    videos.forEach(video => io.observe(video));
    motionButton?.addEventListener('click', () => { pausedByChoice = !pausedByChoice; syncMotion(); });
    motionPreference.addEventListener('change', event => {
      if (event.matches) pausedByChoice = true;
      syncMotion();
    });
    document.addEventListener('visibilitychange', syncMotion);
    addEventListener('pagehide', () => videos.forEach(video => video.pause()));
    syncMotion();
  }

})();
